import { ListPaginationMeta } from "utils/helpers/pagination";

export interface TireTypeRow {
  tireTypeId: number;
  tireCode: string;
  tireTypeName?: string;
}

export interface TireTypeForm {
  sort: string;
  description: string;
  code: string;
}

export enum FieldKind {
  String = "string",
  Number = "number",
}

export const FIELD_KIND: Record<keyof TireTypeForm, FieldKind> = {
  sort: FieldKind.String,
  description: FieldKind.String,
  code: FieldKind.String,
};

export type TireTypeListMeta = ListPaginationMeta;

export interface TireTypeListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: TireTypeRow[];
  meta?: TireTypeListMeta;
}

export interface TireTypeUpdate {
  id: number;
  tireCode: string;
  tireTypeName: string;
}

export interface TireTypeState {
  loading: boolean;
  saving: boolean;
  list: TireTypeRow[];
  page: number;
  perPage: number;
  meta: TireTypeListMeta;
  error: string | null;
  isAddModalOpen: boolean;
  form: TireTypeForm;
}
